import { Injectable } from '@angular/core';
import { DocumentationWindowPhase } from '@app/enums';
import { ValueClockModel } from '@models/index';
import { FlightSummary } from '@models/micro';
import {
  evaluateSegmentDocumentation,
  DocumentationWindowState,
} from '@app/utils/functions/flight-documentation-window';
import moment from 'moment';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

/**
 * Estado emitido por el contador de la ventana de documentación.
 * `h`/`m` representan el tiempo hasta la apertura; `phase` indica si se puede documentar.
 */
export interface DocumentationWindowCountdownInt {
  h: number;
  m: number;
  valid: boolean;
  phase: DocumentationWindowPhase;
}

@Injectable({
  providedIn: 'root',
})
export class ClockService {
  clock: Observable<Date>;
  infofecha$ = new BehaviorSubject<ValueClockModel>(new ValueClockModel());
  vr: ValueClockModel = new ValueClockModel();
  hours = 0;
  minute = '';
  weekday = '';
  months = '';

  constructor() {
    this.clock = timer(0, 1500).pipe(
      map(() => new Date()),
      shareReplay(1)
    );
  }
  getInfoReloj(): Observable<ValueClockModel> {
    this.clock.subscribe((t) => {
      this.hours = t.getHours() % 12;
      this.hours = this.hours ? this.hours : 12;
      this.vr = {
        hora: t.getHours(),
        minutos: t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes().toString(),
        ampm: t.getHours() > 11 ? 'PM' : 'AM',
        diaymes: t
          .toLocaleString('es-MX', { day: '2-digit', month: 'long' })
          .replace('.', '')
          .replace('-', ' '),
        diadesemana: t.toLocaleString('es-MX', { weekday: 'long' }).replace('.', ''),
        segundo: t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds().toString(),
      };
      this.infofecha$.next(this.vr);
    });
    return this.infofecha$.asObservable();
  }

  startCountDown(
    flightSumary: FlightSummary,
    _location: string
  ): Observable<DocumentationWindowCountdownInt> {
    const period = 15 * 1000;

    return timer(0, period).pipe(
      map(() => {
        const result = evaluateSegmentDocumentation(flightSumary?.currentSegment);
        const phase = this.mapWindowStateToPhase(result.windowState);
        const minutesUntilOpen = result.minutesUntilOpen ?? 0;
        const h = minutesUntilOpen > 0 ? Math.floor(minutesUntilOpen / 60) : 0;
        const m = minutesUntilOpen > 0 ? minutesUntilOpen % 60 : 0;

        return {
          h,
          m,
          valid: phase !== DocumentationWindowPhase.OPEN,
          phase,
        };
      }, shareReplay(1))
    );
  }

  private mapWindowStateToPhase(state: DocumentationWindowState): DocumentationWindowPhase {
    switch (state) {
      case 'OPEN':
        return DocumentationWindowPhase.OPEN;
      case 'BEFORE_OPEN':
        return DocumentationWindowPhase.BEFORE_OPEN;
      default:
        return DocumentationWindowPhase.CLOSED;
    }
  }
}
